// Friendly display labels for the four built-in document kinds, whose stored
// values are legacy code strings. User-added kinds have no code/label split —
// their stored Name is already display-ready, so unknown kinds pass through
// unchanged. Keeps existing templates (stored as codes) rendering nicely while
// the kind list becomes per-tenant configurable (v1.3 Item 7).
const BUILT_IN_KIND_LABELS: Record<string, string> = {
  PowerOfAttorney: 'Power of attorney',
  VetAuthorization: 'Vet authorization',
  IncapacitationDirective: 'Incapacitation directive',
  Other: 'Other'
};

export function humanizeDocumentKind(kind: string): string {
  return BUILT_IN_KIND_LABELS[kind] ?? kind;
}

// Built-in kinds that default the "expire after visit" (effective-date-bound)
// checkbox to on when selected. Preserves the prior per-kind default now that
// the kind list is data-driven; user-added kinds leave the checkbox untouched.
const EFFECTIVE_BOUND_DEFAULT_KINDS = new Set(['PowerOfAttorney']);

export function defaultsEffectiveBound(kind: string): boolean {
  return EFFECTIVE_BOUND_DEFAULT_KINDS.has(kind);
}
